import { VehicleType } from '@transferz/fe-models';

export const isSharedVehicleCategory = (vehicleCategory: string) => (
  vehicleCategory === VehicleType.Shuttle
  || vehicleCategory === VehicleType.SpeedyShuttle
  || vehicleCategory === VehicleType.DirectShuttle
  || vehicleCategory === VehicleType.EventShuttle
);
